import React, { useState } from 'react';
import { Box, Button, Card, CardContent, CircularProgress, Container, Link as MuiLink, TextField, Typography, IconButton, InputAdornment } from '@mui/material';
import ThemeToggle from '../components/ThemeToggle';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useNavigate } from 'react-router-dom';
import { performLogin } from '../controllers/authController';
import { useAuth } from '../context/AuthContext';

const Login = () => {
    const navigate = useNavigate();
    const { setSession } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const data = await performLogin({ username, password });
            setSession({ token: data.token, username: data.username, roles: data.roles, expiresAt: data.expiresAt });
            navigate('/');
        } catch (err) {
            setError(err?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100%',
                backgroundImage: 'url(/assets/images/login-background.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Container
                component="main"
                maxWidth="xs"
                sx={{
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                <Card
                    sx={{
                        width: '100%',
                        borderRadius: '10px',
                        boxShadow: 'none',
                        border: '1px solid #e8e8e8 !important',
                    }}
                >
                    <CardContent sx={{ p: 5 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box
                                component="img"
                                src="/assets/images/main-logo.svg"
                                alt="Rotary Club Logo"
                                sx={{
                                    width: 120,
                                    mb: 3,
                                }}
                            />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0, mb: .2 }}>
                                <Typography component="h1" variant="h6" sx={{ fontWeight: 700 }}>Yönetim Paneli</Typography>
                                {/* <ThemeToggle /> */}
                            </Box>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Yönetim paneline giriş yapınız</Typography>
                            <Box component="form" onSubmit={onSubmit} sx={{ mt: 1, width: '100%' }}>
                                <Box sx={{ mb: 3 }}>
                                    <Typography variant="body2" sx={{ mb: .6, fontWeight: 500 }}>
                                        Kullanıcı Adı
                                    </Typography>
                                    <TextField
                                        required
                                        fullWidth
                                        id="username"
                                        name="username"
                                        autoComplete="username"
                                        autoFocus
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeholder=""
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '5px',
                                            },
                                            '& .MuiInputBase-input': {
                                                py: 1.2,
                                                px: 1.5,
                                                fontSize: '14px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#e6e6e6',
                                            },
                                        }}
                                    />
                                </Box>
                                <Box sx={{ mb: 1 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: .6 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            Şifre
                                        </Typography>
                                        {/* <MuiLink
                                            href="#"
                                            variant="body2"
                                            sx={{
                                                fontSize: '13px',
                                                textDecoration: 'none',
                                                color: 'primary.main',
                                                '&:hover': {
                                                    textDecoration: 'underline',
                                                },
                                            }}
                                        >
                                            Şifremi unuttum
                                        </MuiLink> */}
                                    </Box>
                                    <TextField
                                        required
                                        fullWidth
                                        name="password"
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        autoComplete="current-password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder=""
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '5px',
                                            },
                                            '& .MuiInputBase-input': {
                                                py: 1.2,
                                                px: 1.5,
                                                fontSize: '14px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#e6e6e6',
                                            },
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                                                        onClick={() => setShowPassword((v) => !v)}
                                                        edge="end"
                                                        sx={{ color: 'text.secondary' }}
                                                    >
                                                        {showPassword ? <RemoveRedEyeIcon fontSize="small" /> : <RemoveRedEyeOutlinedIcon fontSize="small" />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                {error && (
                                    <Typography variant="body2" color="error" sx={{ mt: 1 }}>{error}</Typography>
                                )}
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        py: 1,
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                        fontSize: '14px',
                                        boxShadow: 'none',
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Giriş Yap'}
                                </Button>
                                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <MuiLink href="#" variant="body2">Şifremi unuttum</MuiLink>
                                <MuiLink href="#" variant="body2">Destek</MuiLink>
                                </Box> */}
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
};

export default Login;


